import {useLocalObservable} from 'mobx-react-lite';
import React from 'react';

import {useDialogController} from '_/hooks';
import {useTablePersistence} from '_/hooks/useTablePersistence';
import {Filter} from '_/utilities';

import {ActiveFiltersDialog} from '../ActiveFilter/ActiveFilter.hooks';
import {ActiveFilters} from '../ActiveFilter/ActiveFilter.store';
import {ActiveState} from '../ActiveFilter/ActiveFilter.types';

export const useUserSearchFilters = ({
  persistenceKey,
  onFilterChange,
  showFilteredOutInfo = false,
}: {
  persistenceKey: string;
  onFilterChange: (activeStateFilter: Filter<ActiveState, true>) => void;
  showFilteredOutInfo?: boolean;
}): {
  persistenceInitialized: boolean;
  searchFilterText: string;
  showSearchFiltersDialog: () => void;
  searchFiltersDialog: React.ReactElement | null;
  initialActiveStateFilter: Filter<ActiveState, true>;
} => {
  const {isVisible, showDialog, closeDialog} = useDialogController();
  const searchFilters = useLocalObservable(() => new ActiveFilters());

  const persistenceInitialized = useTablePersistence({
    key: `userAutocomplete.searchFilters.${persistenceKey}`,
    filters: searchFilters.filters,
  });

  const searchFiltersDialog = isVisible ? (
    <ActiveFiltersDialog
      filters={searchFilters}
      showFilteredOutInfo={showFilteredOutInfo}
      onClose={(updated) => {
        if (updated) {
          onFilterChange(searchFilters.activeFilter);
        }
        closeDialog();
      }}
    />
  ) : null;

  return {
    persistenceInitialized,
    initialActiveStateFilter: searchFilters.activeFilter,
    searchFilterText: searchFilters.activeFilterText,
    showSearchFiltersDialog: showDialog,
    searchFiltersDialog,
  };
};
